// Detects when a chat stream ended cleanly but the model didn't get to
// synthesize a final text reply — the AI SDK's `useChat().error` only fires
// when the provider returned an error event (e.g. Anthropic 30k ITPM).
// OpenAI's MAX_STEPS hit instead emits `finishReason:"tool-calls"` which the
// hook treats as a clean finish, leaving no UI signal. This predicate fills
// that gap so ChatHome can render a banner explaining what actually happened.

export type ChatStatus = "ready" | "streaming" | "submitted" | "error";

export interface ChatLikeMessage {
  role: string;
  parts?: { type: string; text?: string }[];
}

export type IncompleteStopReason = "step-cap";

export function detectIncompleteStop(
  messages: ChatLikeMessage[],
  status: ChatStatus,
  hasError: boolean,
): IncompleteStopReason | null {
  if (status !== "ready" || hasError) return null;
  let lastAssistant: ChatLikeMessage | undefined;
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].role === "assistant") {
      lastAssistant = messages[i];
      break;
    }
  }
  if (!lastAssistant) return null;
  const parts = lastAssistant.parts ?? [];
  const hasTools = parts.some((p) => p.type.startsWith("tool-"));
  const hasText = parts.some(
    (p) => p.type === "text" && typeof p.text === "string" && p.text.trim().length > 0,
  );
  if (hasTools && !hasText) return "step-cap";
  return null;
}
